const AdsSlots = Object.freeze({
    GPT_IFRAME_BANNER_320_SLOT_1      : 'GPT_IFRAME_BANNER_320_SLOT_1',
    OUTBRAIN_IFRAME_BANNER_320_SLOT_1 : 'OUTBRAIN_IFRAME_BANNER_320_SLOT_1',
    GPT_INLINE_BANNER_320_SLOT_1      : 'GPT_INLINE_BANNER_320_SLOT_1',
    GPT_INLINE_BANNER_320_SLOT_2      : 'GPT_INLINE_BANNER_320_SLOT_2',
    GPT_INLINE_BANNER_320_SLOT_3      : 'GPT_INLINE_BANNER_320_SLOT_3',
});

export default AdsSlots;
